// src/pages/SafariZoneEast.jsx
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";
import SafariZoneTimer from '../../components/SafariZoneTimer';
import withSafariZoneProtection from '../../components/SafariZoneProtection';

const SafariZoneEast = () => {
  return (
    <>
      <GameMap config={mapConfigs.safariZoneEast} />
      <SafariZoneTimer />
    </>
  );
};

export default withSafariZoneProtection(SafariZoneEast);